import { Cart } from '@adapters/bigcommerce/types/cart';
import { waitForFindify } from '@findify/react-bundle';

const findifyAnalyticsUpdateCart = async ({ data }: { data: Cart | null }) => {
  const { analytics } = await waitForFindify();
  analytics.sendEvent('update-cart', {
    line_items: Object.values(data?.cartData?.line_items ?? {})
      .flatMap((category) => category)
      .map((item) => ({
        item_id: item.product_id.toString(),
        quantity: item.quantity,
        unit_price: item.sale_price, // populates with regular price when not on sale
        variant_item_id: `${item.product_id}-${item.sku}`,
      })),
  });
};

export default findifyAnalyticsUpdateCart;
